import { connect } from 'react-redux';

import Component from '../../components/js/modules/SetMiffyBucket';
import { IStates } from '../CommonStateType';

const mapStateToProps = (state: IStates, ownProps?: { adExperimentId?: string }) => {
  const adBucketId =
    state.userData.abTestBuckets?.find(test => test.experimentId === ownProps?.adExperimentId)?.bucket ?? undefined;

  return {
    adBucketId,
    adTypeTag: getPcAdTypeTag(state.userData.abTestBuckets)
  };
};

const getPcAdTypeTag = (abTestBuckets: IStates['userData']['abTestBuckets'] | null): string | undefined => {
  return (
    abTestBuckets
      // トピックス見出しABテストのエクスペリメントは広告のタグに反映されないようにする
      ?.filter(test => !test.isTopicsHeadingTest)
      .map(test => test.bucket)
      // 空文字・nullを取り除く
      .filter(bucket => !!bucket)
      .join('-')
  );
};
export default connect(mapStateToProps)(Component);
